<div [loading]="loading()">
	@if(cardSets().length>0){
		<ul class="list bg-base-100 rounded-box shadow-md">
		  <li class="p-4 pb-2 text-xs opacity-60 tracking-wide">Liste des series</li>
		    @for(cardSet of cardSets(); track cardSet.ident){
			  <li class="element-show list-row" [style.--i]="(($index<15)? $index : 0)">
			    <div class="logo-set">
			    	<div>
				    	<img [altImg]="cardS.getLogos(cardSet.logo)" [attr.loading]="(($index>10)? 'lazy' : false)"/>
				    </div>
			    </div>
			    <div>
			      <div>
			      	<!-- @if(cardSet.symbol){
				      	<img class="symbol-set" [src]="cardS.getSymbol(cardSet.symbol)"/>
				    } -->
			      	{{cardS.getCardSetName(cardSet, 'fr')}}
			      </div>
			      <div class="text-xs font-semibold opacity-60">
			      	<progress class="progress progress-gradient violet w-56" [value]="getPercent(cardSet)" max="100"></progress>
			      	<p class="progression">{{getNbCard(cardSet)}}/{{cardSet.nbCard}} cartes ({{getPercent(cardSet) | number:'1.0-2':'fr-FR' }}%)</p>
			      </div>
			    </div>
			    <a href="#" [routerLink]="router.parse('stat-serie', [cardSet.ident])" class="btn text-primary btn-square btn-ghost">
					<i class="fa-light fa-eyes"></i>
			    </a>
			  </li>
			}
		</ul>
	}
	@else{
		<lgb-comming-soon></lgb-comming-soon>
	}
</div>